import React, { useEffect } from 'react'
import { Platform } from 'react-native'

import useMyCustomersStore from '@zet/customer/src/store/myCustomers'
import { B1, B2, Stack, XStack, colors } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'
import RadioOff from '@zet/design-system/svg/RadioOff'
import RadioOn from '@zet/design-system/svg/RadioOn'
import { useCategories } from '@zet/feature-brands/api/brands/hooks'
import { i18n } from '@zet/localization'
import { LOANS_CATEGORY, customerInterestList } from '@zet/utils/Constants'
import { useUnsafeVariable } from 'nativewind'

const CustomerInterest = () => {
  const { customerIntent, setCustomerIntent } = useMyCustomersStore(
    (state) => state
  )
  const { data: categories } = useCategories({ enabled: true })
  const [colorPrimary100] = useUnsafeVariable('--color-primary-100')

  useEffect(() => {
    let customerIntent = ''
    if (Platform.OS === 'web' && categories && categories?.length) {
      for (const category of categories) {
        if (LOANS_CATEGORY.includes(category?.categoryId)) {
          customerIntent = 'LOANS'
          break
        } else if (category?.categoryId === 15) {
          customerIntent = 'CC'
          break
        }
      }
    }
    setCustomerIntent(customerIntent)
  }, [categories, setCustomerIntent])

  if (
    Platform.OS === 'web' &&
    categories &&
    ![9, 15].every((id) =>
      categories.some((category) => category.categoryId === id)
    )
  ) {
    return <></>
  }
  return (
    <Stack className="mt-3">
      <B2 className="text-grays-80 mb-2 ml-1">
        {i18n.t('knowCustomer.customerInterestTitle')}
        <B1 className="text-error-100 ml-1">*</B1>
      </B2>

      <XStack className="items-center space-x-3">
        {customerInterestList.map(({ id, title }) => (
          <Pressable
            className={`items-center rounded-md border px-2 py-1.5 ${
              customerIntent === id
                ? 'border-primary-100 bg-gray-5'
                : 'border-grays-40'
            }`}
            key={id}
            onPress={() => setCustomerIntent(id)}
            opacity
          >
            <XStack className="items-center gap-2">
              {customerIntent === id ? (
                <RadioOn size={12} color={colorPrimary100} />
              ) : (
                <RadioOff size={12} color={colors.grays[50]} />
              )}
              <B2
                className={`${
                  customerIntent === id ? 'text-primary-100' : 'text-grays-60'
                }`}
              >
                {title}
              </B2>
            </XStack>
          </Pressable>
        ))}
      </XStack>
    </Stack>
  )
}

export default CustomerInterest
